// src/context/ThemeContext.js
// Thème clair par défaut, accent vert discret et cohérent clair/sombre - NE PAS MODIFIER

import React, { createContext, useState, useEffect, useCallback } from 'react';

export const ThemeContext = createContext();

// Palette SOMBRE - accent vert discret assorti au clair (accessible via le bouton)
const darkTheme = {
  mode: 'dark',
  bg: '#0A0E1A',
  bgCard: '#162033',
  bgInput: '#111827',
  bgElevated: '#1C2537',
  textPrimary: '#FFFFFF',
  textSecondary: '#A0AEC0',
  textMuted: '#4A5568',
  gold: '#4C9A6A', // vert discret, cohérent avec le thème clair
  goldSoft: 'rgba(76, 154, 106, 0.15)',
  goldBorder: 'rgba(76, 154, 106, 0.3)',
  border: 'rgba(255, 255, 255, 0.1)',
  borderSoft: 'rgba(255, 255, 255, 0.05)',
  navBg: '#0A0E1A',
  overlay: 'rgba(0, 0, 0, 0.6)',
  shadow: '0 10px 25px rgba(0, 0, 0, 0.5)',
};

// Palette CLAIRE (défaut) - blanc pur, vert très discret en accent uniquement
const lightTheme = {
  mode: 'light',
  bg: '#FFFFFF',
  bgCard: '#FAFBFA',
  bgInput: '#F2F4F2',
  bgElevated: '#FFFFFF',
  textPrimary: '#0F1419',
  textSecondary: '#5A6472',
  textMuted: '#9AA3AF',
  gold: '#2F7A52', // vert forêt discret, professionnel, pas criard
  goldSoft: 'rgba(47, 122, 82, 0.08)',
  goldBorder: 'rgba(47, 122, 82, 0.25)',
  border: 'rgba(0, 0, 0, 0.08)',
  borderSoft: 'rgba(0, 0, 0, 0.05)',
  navBg: '#FFFFFF',
  overlay: 'rgba(0, 0, 0, 0.5)',
  shadow: '0 10px 25px rgba(0, 0, 0, 0.10)',
};

export const ThemeProvider = ({ children }) => {
  const [mode, setMode] = useState('light'); // clair par défaut

  useEffect(() => {
    const saved = localStorage.getItem('fynho_theme');
    if (saved === 'light' || saved === 'dark') {
      setMode(saved);
    }
  }, []);

  useEffect(() => {
    const theme = mode === 'light' ? lightTheme : darkTheme;
    document.body.style.backgroundColor = theme.bg;
    document.body.style.color = theme.textPrimary;
    localStorage.setItem('fynho_theme', mode);
  }, [mode]);

  const toggleTheme = useCallback(() => {
    setMode((prev) => (prev === 'dark' ? 'light' : 'dark'));
  }, []);

  const theme = mode === 'light' ? lightTheme : darkTheme;

  const value = {
    theme,
    mode,
    toggleTheme,
    isDark: mode === 'dark',
    isLight: mode === 'light',
  };

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};